<template>
  <div
    class="tab"
    :style="{
      backgroundColor: tabAttr.backgroundColor,
      border: tabAttr.border,
    }"
  >
    <BCheckbox v-model.lazy="checked" :type="tabAttr.type" :disabled="true">
      {{ tabAttr.title | t }}
    </BCheckbox>
    <p class="total">
      {{ computedTabTotal }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    tabAttr: Object, // eslint-disable-line vue/require-default-prop
    tabTotal: [Number, String], // eslint-disable-line vue/require-default-prop
    itemStatus: Array, // eslint-disable-line vue/require-default-prop
    selected: Boolean,
  },
  computed: {
    checked: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit("selectedTabsChange", {
          value: this.tabAttr.name,
          change: value,
        });
      },
    },
    computedTabTotal() {
      if (!Number.isInteger(this.tabTotal)) return this.tabTotal;
      return this.$options.filters.numberFormat(this.tabTotal, "0,0");
    },
  },
};
</script>

<style lang="scss" scoped>
.tab {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 18%;
  padding: 15px;
  border-radius: $border-radius;
  color: $white;
  font-size: 14px;
  white-space: normal;
  vertical-align: top;
}

.total {
  margin-top: 15px;
  font-size: 22px;
  text-align: right;
}

.checkbox {
  align-items: flex-start !important;

  &:hover {
    color: $white;
    text-decoration: underline;
  }
}
</style>
<style lang="scss">
.tab {
  .checkbox .check {
    border-color: $white !important;
  }
  // temporarily remove checkboxes
  .b-checkbox {
    color: #fff !important;
    cursor: auto !important;
    opacity: 1 !important;

    input,
    .check {
      display: none !important;
    }
  }
}
</style>
